module.exports = __webpack_public_path__ + "static/media/under-construction.e65696c9.svg";